






















import { capitalizeString } from '~/utils/string'
import { faBan, faStar, faTrash } from '@fortawesome/free-solid-svg-icons'
import PromoButton from '~/components/car/classifieds/promote/PromoButton.vue'
import PromoStats from '~/components/car/classifieds/promote/PromoStats.vue'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { PromoStats, PromoButton },
  props: {
    activePromotion: {
      type: Object,
      required: true
    },
    actionPending: { type: Boolean, default: false },
    preferredPayment: { type: String, default: 'credits' }
  },
  computed: {
    icons() {
      return {
        star: faStar,
        trash: faTrash,
        ban: faBan
      }
    },
    stats() {
      return this.activePromotion.stats || null
    }
  },
  methods: {
    getTitleForTier(tier: string) {
      // for now just capitalize
      return capitalizeString(tier)
    }
  }
})
